import { render, staticRenderFns } from "./AsiMarkDownEditor.vue?vue&type=template&id=38d7fba8&scoped=true"
import script from "./AsiMarkDownEditor.vue?vue&type=script&lang=ts"
export * from "./AsiMarkDownEditor.vue?vue&type=script&lang=ts"
import style0 from "./AsiMarkDownEditor.vue?vue&type=style&index=0&id=38d7fba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7fba8",
  null
  
)

export default component.exports